const indexItems = [
  { id: 1, title: '少年热血', count: '3,286部', icon: 'ri-flashlight-line', desc: 'JUMP系为主的热血战斗漫画' },
  { id: 2, title: '少女恋爱', count: '2,154部', icon: 'ri-heart-line', desc: '甜蜜细腻的恋爱故事合集' },
  { id: 3, title: '悬疑推理', count: '987部', icon: 'ri-search-eye-line', desc: '烧脑推理与悬疑佳作' },
  { id: 4, title: '异世界', count: '1,432部', icon: 'ri-earth-line', desc: '异世界转生与奇幻冒险' },
  { id: 5, title: '搞笑日常', count: '1,876部', icon: 'ri-emotion-laugh-line', desc: '轻松搞笑的日常喜剧' },
  { id: 6, title: '恐怖灵异', count: '645部', icon: 'ri-ghost-line', desc: '让人脊背发凉的恐怖作品' },
  { id: 7, title: '运动竞技', count: '734部', icon: 'ri-basketball-line', desc: '热血激昂的体育竞技' },
  { id: 8, title: '科幻未来', count: '521部', icon: 'ri-rocket-line', desc: '未来科技与科幻想象' },
  { id: 9, title: '历史时代', count: '398部', icon: 'ri-ancient-gate-line', desc: '历史背景的日漫佳作' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            分类浏览
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="text-foreground-500 text-sm mt-2">按主题类型探索你感兴趣的日漫世界</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex items-start gap-4 p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-background-300 cursor-pointer transition-all"
            >
              <div className="w-10 h-10 flex-shrink-0 rounded-xl bg-secondary-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-lg text-secondary-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}